import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations } from 'vuex';
import TransitionExpand from '~/components/templates/TransitionExpand.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cross.svg';
import { searchFiltersLabels } from '~/const/listing/algolia';
export default {
  name: 'CategoryFiltersBar',
  components: {
    TransitionExpand: TransitionExpand
  },
  props: {
    activeFilters: {
      type: Array,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  methods: _objectSpread(_objectSpread({}, mapMutations({
    filterBy: 'pageActions/FILTER_BY',
    resetFilters: 'pageActions/RESET_FILTERS'
  })), {}, {
    removeFilter: function removeFilter(tag) {
      this.filterBy({
        filter: tag.filter,
        facet: tag.facet
      });
    },
    reset: function reset() {
      this.$emit('on-reset-filters');
      this.resetFilters();
    },
    getTagLabel: function getTagLabel(activeFilter) {
      if (activeFilter.filter === 'more_info') return searchFiltersLabels[activeFilter.label] || activeFilter.label;
      return activeFilter.filter === 'price' ? this.formatCurrency(activeFilter.label) : activeFilter.label;
    },
    activeFilterLabel: function activeFilterLabel(activeFilter) {
      return ['depth', 'width', 'height'].includes(activeFilter.filter) ? "".concat(this.$t(activeFilter.filter), ": ").concat(this.getTagLabel(activeFilter)) : this.getTagLabel(activeFilter);
    },
    formatCurrency: function formatCurrency(value) {
      var _this = this;

      var prices = value.split('-');
      var formattedPrices = [];
      prices.forEach(function (price) {
        formattedPrices.push(new Intl.NumberFormat(_this.locale.iso, {
          style: 'currency',
          currency: _this.locale.currency,
          maximumSignificantDigits: 3
        }) // eslint-disable-next-line
        .format(price));
      });
      return formattedPrices.join(' - ');
    }
  })
};